import { render, staticRenderFns } from "./editcollector.vue?vue&type=template&id=3c254673&"
import script from "./editcollector.vue?vue&type=script&lang=ts&"
export * from "./editcollector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editcollector.vue"
export default component.exports